import * as actionTypes from "./actionTypes";

/*===== START =====*/
// store under param voucherQuantity in consumer_reducer.js
export const storeQuantity = (data) => {
  return {
    type: actionTypes.STORE_QUANTITY,
    data,
  };
};
export const clearQuantity = () => {
  return {
    type: actionTypes.CLEAR_QUANTITY,
  };
};
/*====== END ======*/

/*===== VOUCHER ACTION =====*/
export const onLoadHomeSpecialOffer = (data) => {
  return {
    type: actionTypes.HOME_SPECIAL_OFFER,
    data,
  };
};
export const onLoadHomeSpecialOfferSuccess = (data) => {
  return {
    type: actionTypes.HOME_SPECIAL_OFFER_SUCCESS,
    data,
  };
};
export const getVoucherDetail = (id) => {
  return {
    type: actionTypes.LOAD_VOUCHER_DETAILS,
    id,
  };
};

export const getVoucherDetailSuccess = (data) => {
  return {
    type: actionTypes.LOAD_VOUCHER_DETAILS_SUCCESS,
    data,
  };
};

export const getMyVoucherDetails = (id) => {
  return {
    type: actionTypes.LOAD_MY_VOUCHER_DETAILS,
    id,
  };
};

export const getMyVoucherDetailsSuccess = (data) => {
  return {
    type: actionTypes.LOAD_MY_VOUCHER_DETAILS_SUCCESS,
    data,
  };
};

export const loadVoucherFoodMedia = (data) => {
  return {
    type: actionTypes.LOAD_VOUCHER_FOODMEDIA,
    data,
  };
};

export const loadVoucherFoodMediaSuccess = (data, total) => {
  return {
    type: actionTypes.LOAD_VOUCHER_FOODMEDIA_SUCCESS,
    data,
    total,
  };
};

export const loadVoucherFoodMediaFail = (data) => {
  return {
    type: actionTypes.LOAD_VOUCHER_FOODMEDIA_FAIL,
    data,
  };
};

export const getMyVoucherList = (data) => {
  return {
    type: actionTypes.GET_MY_VOUCHER_LIST,
    data,
  };
};
export const getMyVoucherListSuccess = (filterData, data) => {
  return {
    type: actionTypes.GET_MY_VOUCHER_LIST_SUCCESS,
    filterData,
    data,
  };
};
export const getMyVoucherListFail = (msg) => {
  return {
    type: actionTypes.GET_MY_VOUCHER_LIST_FAIL,
    msg,
  };
};
export const clearPromo = (promo_code = false) => {
  return {
    type: actionTypes.CLEAR_PROMO,
    promo_code,
  };
};
export const getPromo = (data) => {
  return {
    type: actionTypes.GET_PROMO,
    data,
  };
};
export const getPromoSuccess = (filterData, data) => {
  return {
    type: actionTypes.GET_PROMO_SUCCESS,
    filterData,
    data,
  };
};
export const getPromoFail = () => {
  return {
    type: actionTypes.GET_PROMO_FAIL,
  };
};
export const loadVoucherList = (data, restID = null, status = null) => {
  return {
    type: actionTypes.LOAD_VOUCHER_LIST,
    data,
    restID,
    status,
  };
};

export const loadVoucherListSuccess = (status, data) => {
  return {
    type: actionTypes.LOAD_VOUCHER_LIST_SUCCESS,
    status,
    data,
  };
};

export const loadVoucherListFail = () => {
  return {
    type: actionTypes.LOAD_VOUCHER_LIST_FAIL,
  };
};

export const refundVoucher = (data) => {
  return {
    type: actionTypes.REFUND_VOUCHER,
    data,
  };
};
export const refundVoucherSuccess = (data) => {
  return {
    type: actionTypes.REFUND_VOUCHER_SUCCESS,
  };
};

export const redeemVoucher = (data) => {
  return {
    type: actionTypes.REDEEM_VOUCHER,
    data,
  };
};
export const redeemVoucherSuccess = () => {
  return {
    type: actionTypes.REDEEM_VOUCHER_SUCCESS,
  };
};
export const buyVoucher = (data) => {
  return {
    type: actionTypes.BUY_VOUCHER,
    data,
  };
};
export const buyVoucherSuccess = () => {
  return {
    type: actionTypes.BUY_VOUCHER_SUCCESS,
  };
};
export const buyVoucherFail = (data) => {
  return {
    type: actionTypes.BUY_VOUCHER_FAIL,
    data,
  };
};
export const loadAllVoucher = (data) => {
  return {
    type: actionTypes.LOAD_ALL_VOUCHER,
    data,
  };
};
export const loadAllVoucherSuccess = (data) => {
  return {
    type: actionTypes.LOAD_ALL_VOUCHER_SUCCESS,
    data,
  };
};
export const loadAllVoucherFail = (data) => {
  return {
    type: actionTypes.LOAD_ALL_VOUCHER_FAIL,
    data,
  };
};
